module.exports = __webpack_public_path__ + "static/media/datasheet_onDemandPrinting_row2_product_image.4d69b567.png";